<template>
  <responsive-modal
    id="integration-modal"
    v-model="show"
    :title="isEdit ? 'Editar' : `Integração com ${title}`"
  >
    <a :href="link" v-if="link" target="_blank" class="integration-link mb-4">
      Conheça a {{ title }}
      <i class="ph ph-arrow-square-out" />
    </a>
    <slot>
      <component :is="content" @close="close" />
    </slot>
  </responsive-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "lg"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    title: String,
    content: Object,
    link: String
  },
  data() {
    return {
      show: this.value
    };
  },
  methods: {
    close() {
      this.show = false;
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    }
  }
};
</script>
